import classNames from 'classnames'
import React, { useState } from 'react'

import { Icon } from '../icon'

import styles from './colorFilter.module.scss'
import { isLightColor, isWhiteColor } from './colorFilter.utils'
import CheckIcon from './icons/check.inline.svg'
export interface ColorFilterProps {
  hex: string
  imgURL?: string | null
  label: string
  value: string
  selected?: boolean
  onChange?: (value: string) => void
  className?: string
  circleClassName?: string
  labelClassName?: string
  style?: React.CSSProperties
}

export const ColorFilter: React.FC<ColorFilterProps> = ({
  hex,
  imgURL = null,
  label,
  value,
  selected = false,
  onChange,
  className,
  circleClassName,
  labelClassName,
  style,
}) => {
  const [isHovered, setIsHovered] = useState(false)

  // Truncate color names longer than 10 characters
  const displayLabel = label.length > 10 ? `${label.substring(0, 8)}..` : label

  const handleClick = () => {
    if (onChange) {
      onChange(value)
    }
  }

  const containerClasses = classNames(styles.container, className)

  const circleClasses = classNames(
    styles.circle,
    selected ? styles.selected : undefined,
    isHovered && !selected ? styles.hovered : undefined,
    imgURL ? styles.hasImage : undefined,
    hex && isWhiteColor(hex) ? styles.whiteColor : undefined,
    circleClassName,
  )

  const labelClasses = classNames(styles.label, { [styles.selected as string]: selected }, labelClassName)
  const circleStyle = {
    ...(imgURL ? { backgroundImage: `url(${imgURL})` } : { backgroundColor: hex }),
    ...style,
  }
  const colorDescription = imgURL ? `Color pattern: ${label}` : `Color: ${label}, hex code ${hex}`

  // Determine checkmark color based on background color
  const checkmarkClasses = classNames(
    styles.checkmark,
    (imgURL ?? isLightColor(hex)) ? styles.darkCheckmark : undefined,
  )

  return (
    <div
      className={containerClasses}
      onMouseEnter={() => {
        setIsHovered(true)
      }}
      onMouseLeave={() => {
        setIsHovered(false)
      }}
      onClick={handleClick}
      aria-roledescription="color swatch"
    >
      <button
        type="button"
        className={circleClasses}
        style={circleStyle}
        aria-pressed={selected}
        aria-label={colorDescription}
      >
        {selected && (
          <div className={styles.checkmarkContainer}>
            <Icon iconSvg={CheckIcon} className={checkmarkClasses} />
          </div>
        )}
      </button>
      <span
        className={labelClasses}
        id={`color-label-${value.replace(/\s+/g, '-')}`}
        title={label.length > 10 ? label : undefined}
      >
        {displayLabel}
      </span>
    </div>
  )
}
